import * as styles from './header-nav.module.css'

export interface HeaderNavProps {
  title?: string
  backgroundColor?: '#FFFFFF' | '#000000'
}

export const HeaderNav = (props: HeaderNavProps): JSX.Element => (
  <>
    <header id="header" className={styles.header} {...props}>
      <nav style={{ height: 64 }}>
        <div>{props.title}</div>
        <div>dummy</div>
      </nav>
    </header>
  </>
)

export default HeaderNav
